module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "number"
  }, _vm._l((_vm.data), function(item, index) {
    return _c('span', {
      class: 'bg s_' + item
    })
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c0afed2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/number/index.vue
// module id = 133
// module chunks = 1